/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import{clamp as e}from"../../core/mathUtils.js";import{classes as t}from"./widgetUtils.js";import"../../core/has.js";import"../../core/Logger.js";import{tsx as o}from"./jsxFactory.js";const r={heading:"esri-widget__heading"};function s(s,i){const c=`h${e(Math.ceil(s.level),1,6)}`;return delete s.level,o(c,{...s,class:t(r.heading,s.class)},i)}export{r as CSS,s as Heading};
